import { InjectionToken, Signal } from '@angular/core';

/**
 * What the carry-over wrapper draws from, and what it runs when the user
 * presses the button.
 *
 * This is a `ui` library, so it cannot inject a report store. A form provides
 * the source from a directive on the wrapper: the vessel report form uses
 * `nspCarryOver`. A second form, such as the offshore report, adds its own
 * directive and uses the same wrapper.
 */
export interface CarryoverSource {
  /**
   * The value the button writes. Undefined means the template has nothing to
   * write, and the button greys.
   */
  readonly value: Signal<unknown>;
  /** Whether the field draws the button at all. */
  readonly showButton: Signal<boolean>;
  /** Whether a lock stops the button running. */
  readonly buttonDisabled: Signal<boolean>;
  /** Writes the value into the form. */
  apply(): void;
}

export const CARRYOVER_SOURCE = new InjectionToken<CarryoverSource>('CARRYOVER_SOURCE');
